import * as countriesRepositoryRaw from '../assets/countries.json';
import * as statesRepositoryRaw from '../assets/states.json';
import * as formatsRepositoryRaw from '../assets/formats.json';

const countriesRepository: Record<string, any> = countriesRepositoryRaw;
const statesRepository: Record<string, any> = statesRepositoryRaw;
const formatsRepository: Record<string, any> = formatsRepositoryRaw;

export default {
	/**
	 * Return a list of countries
	 *
	 * @return
	 */
	countriesList: () => {
		return countriesRepository || {};
	},

	/**
	 * Get states list by country ISO code
	 *
	 * @param country_code
	 * @return
	 */
	statesList: (country_code: string) => {
		if (!Object.prototype.hasOwnProperty.call(statesRepository || {}, country_code)) {
			return {};
		}

		return statesRepository[country_code] || {};
	},

	/**
	 * Get phone and zip formats list by country ISO code
	 *
	 * @param country_code
	 * @return
	 */
	formatsList: (country_code: string) => {
		if (!Object.prototype.hasOwnProperty.call(formatsRepository || {}, country_code)) {
			return {};
		}

		return formatsRepository[country_code] || {};
	},
}
